import React from 'react';
import './App.css';
import Post from './components/Post';

function App() {
  return (
    <div className="App">
      <Post />
    </div>
  );
}

export default App;
